const Help = {
    properties: 'top = 200, left = 150, width = 790, height = 500, scrollbars = yes, resizable = yes, status = no',
};
export default {
    Help,
};
